export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_7135_HIDE_USERS': 'Hide Users',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_7131_PREVIOUS_SUPERGROUPS': 'Previous SuperGroups',
    '_834_SELECT_A_SUPERGROUP': 'Select a SuperGroup',
    '_7134_SHOW_USERS': 'Show Users',
    '_4130_SHOW_ALL': 'Show all',
    '_147_SUPERGROUPS': 'SuperGroups'
};
